<template>
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="share_edit"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span aria-hidden="true">×</span>
          </button>
          <ul class="nav nav-tabs modal-tabs" id="myTab">
            <li v-if="shareInfo.share_type === 'link'">
              <a data-toggle="tab" href="#link">编辑链接分享</a>
            </li>
            <li v-if="shareInfo.share_type === 'user'">
              <a data-toggle="tab" href="#user">编辑用户分享</a>
            </li>
            <li v-if="shareInfo.share_type === 'group'">
              <a data-toggle="tab" href="#group">编辑群组分享</a>
            </li>
          </ul>
        </div>
        <div class="modal-body">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade in active" :id="shareInfo.share_type">
              <div class="prompt" v-if="shareInfo.share_type === 'link'">
                <span class="text-danger2"
                  >请各位师生遵守<a
                    target="_blank"
                    href="http://www.gov.cn/zwgk/2013-02/08/content_2330133.htm"
                    >《信息网络传播权保护条例》</a
                  >，勿分享侵权违法内容。</span
                ><br />
                <i class="ti-link"></i
                >创建一个分享链接，可设置密码和有效期策略。
              </div>
              <div class="prompt" v-if="shareInfo.share_type === 'user'">
                <span class="text-danger2"
                  >请各位师生遵守<a
                    target="_blank"
                    href="http://www.gov.cn/zwgk/2013-02/08/content_2330133.htm"
                    >《信息网络传播权保护条例》</a
                  >，勿分享侵权违法内容。</span
                ><br />
                <i class="ti-user"></i>输入姓名/GID/邮箱，搜索要分享的用户。
              </div>
              <div class="prompt" v-if="shareInfo.share_type === 'group'">
                <span class="text-danger2"
                  >请各位师生遵守<a
                    target="_blank"
                    href="http://www.gov.cn/zwgk/2013-02/08/content_2330133.htm"
                    >《信息网络传播权保护条例》</a
                  >，勿分享侵权违法内容。</span
                ><br />
                <i class="ti-user"></i
                >分享给指定群组，群组成员都可以访问分享的资源。
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  placeholder="分享标题"
                  type="text"
                  v-model="shareInfo.share_title"
                  disabled
                />
              </div>

              <div
                class="form-group user-search-from3"
                v-if="shareInfo.share_type === 'user'"
              >
                <div class="share-user">
                  <div
                    class="list"
                    v-for="user in form.share_sharers"
                    :key="user.sharer_number"
                  >
                    <img :src="user.sharer_avatar" />
                    <p>
                      {{ user.sharer_name }}
                      <span v-show="user.name">({{ user.name }})</span>
                    </p>
                    <i
                      class="iconfont icon-close close"
                      @click="removeUser(user)"
                    ></i>
                  </div>
                  <input
                    ref="userSearch"
                    type="text"
                    class="share-input"
                    v-model="searchUserName"
                    placeholder="输入姓名/GID/邮箱，进行精确搜索"
                  />
                  <div
                    class="share-search user-search-to3"
                    v-show="searchUsers.length && showSearchList"
                  >
                    <ul>
                      <li
                        v-for="user in searchUsers"
                        :key="user.number"
                        @click="addUser(user)"
                      >
                        <a>
                          <img
                            :src="user.avatar"
                            style="
                              width: 30px;
                              height: 30px;
                              border-radius: 15px;
                            "
                          />
                          {{ user.name }}（{{ user.email }}）
                          <span
                            :class="[
                              'glyphicon',
                              user.exist
                                ? 'glyphicon-minus-sign'
                                : 'glyphicon-plus-sign',
                            ]"
                            aria-hidden="true"
                          ></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div
                    class="share-search user-search-to3"
                    v-show="noSearchUsers && showSearchList"
                    v-clickoutside="closeSearchList"
                  >
                    <ul>
                      <li>
                        <a>未搜索到任何用户</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div
                class="form-group group-search-from3"
                v-if="shareInfo.share_type === 'group'"
              >
                <div class="share-user">
                  <div
                    class="list"
                    v-for="group in form.share_sharers"
                    :key="group.sharer_number"
                  >
                    <img :src="group.sharer_avatar" />
                    <p>{{ group.sharer_name }}</p>
                    <i
                      class="iconfont icon-close close"
                      @click="removeGroup(group)"
                    ></i>
                  </div>
                  <input
                    ref="groupSearch"
                    type="text"
                    class="share-input"
                    v-model="searchGroupName"
                    placeholder="输入群组名或群号搜索"
                    @focus="groupSearch"
                  />
                  <div
                    class="share-search group-search-to3"
                    v-show="searchGroups.length && showSearchList"
                    v-clickoutside="closeSearchList"
                  >
                    <ul>
                      <li
                        v-for="group in searchGroups"
                        :key="group.number"
                        @click="addGroup(group)"
                      >
                        <a>
                          <img
                            :src="group.group_logo"
                            style="
                              width: 30px;
                              height: 30px;
                              border-radius: 15px;
                            "
                          />
                          {{ group.group_name }}
                          <span
                            :class="[
                              'glyphicon',
                              group.exist
                                ? 'glyphicon-minus-sign'
                                : 'glyphicon-plus-sign',
                            ]"
                            aria-hidden="true"
                          ></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div
                    class="share-search group-search-to3"
                    v-show="noSearchGroups && showSearchList"
                    v-clickoutside="closeSearchList"
                  >
                    <ul>
                      <li>
                        <a>未搜索到任何已加入的群组</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <span class="help-block" v-show="errors.has('group')">{{
                  errors.first("group")
                }}</span>
              </div>

              <div
                aria-controls="collapseExample11"
                aria-expanded="true"
                class="form-group"
                data-toggle="collapse"
                href="#collapseExample11"
                @click="setStrategy"
              >
                设置策略
                <i
                  :class="{
                    'ti-angle-up': strategy,
                    'ti-angle-down': !strategy,
                  }"
                ></i>
              </div>
              <div class="share-tactics collapse in" id="collapseExample11">
                <div class="form-group" v-if="shareInfo.share_type === 'link'">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="密码"
                      v-model="form.password"
                      name="password"
                      data-vv-as="密码 "
                      v-validate="{ min: 4, max: 10 }"
                    />
                    <span class="input-group-btn">
                      <button
                        class="btn btn-link"
                        type="button"
                        @click="createPassword"
                      >
                        自动生成
                      </button>
                    </span>
                  </div>
                  <span class="help-block" v-show="errors.has('password')">{{
                    errors.first("password")
                  }}</span>
                </div>
                <div class="form-group">
                  <div class="input-group" @click="getFormatDateFocus">
                    <input
                      class="form-control"
                      placeholder="有效期"
                      type="text"
                      v-model="form.date"
                      name="date"
                      data-vv-as="有效期 "
                      v-validate="'date_format:yyyy-MM-dd'"
                    />
                    <div class="input-group-addon">
                      <i class="ti-calendar"></i>
                    </div>
                  </div>
                  <span class="help-block" v-show="errors.has('date')">{{
                    errors.first("date")
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">
            取消
          </button>
          <button class="btn btn-primary" type="button" @click="editShare">
            确定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { editShare } from "@/api/share/share";
import { getIcon } from "@/utils/icon";
import { getGroups } from "@/api/group/group";
import { userSearch } from "@/api/user/user";
import { getFormatDate } from "@/utils/index";
export default {
  name: "TableShareEdit",
  data() {
    return {
      showSearchList: true,
      noSearchUsers: false,
      noSearchGroups: false,
      searchUserName: "",
      searchGroupName: "",
      searchUsers: [],
      searchGroups: [],
      strategy: true,
      form: {
        date: "",
        password: "",
        share_sharers: [],
      },
    };
  },
  created() {
    this.debouncedUserSearch = debounce(this.userSearch, 500);
    this.debouncedGroupSearch = debounce(this.groupSearch, 500);
  },
  computed: {
    shareInfo() {
      return this.$store.state.drive.shareInfo;
    },
  },
  watch: {
    searchUserName: {
      handler: function (newValue) {
        if (newValue.trim()) {
          this.debouncedUserSearch();
        } else {
          this.noSearchUsers = false;
        }
      },
    },
    searchGroupName: {
      handler: function (newValue) {
        if (newValue.trim()) {
          this.debouncedGroupSearch();
        } else {
          this.noSearchGroups = false;
        }
      },
    },
  },
  directives: {
    clickoutside: {
      bind(el, binding, vnode) {
        function documentHandler(e) {
          // 这里判断点击的元素是否是本身，是本身，则返回
          if (el.contains(e.target)) {
            return false;
          }
          // 判断指令中是否绑定了函数
          if (binding.expression) {
            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
            binding.value(e);
          }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener("click", documentHandler);
      },
      unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener("click", el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      },
    },
  },
  methods: {
    closeSearchList() {
      this.showSearchList = false;
      this.searchUserName = "";
      this.searchGroupName = "";
    },
    addUser(data) {
      this.errors.remove("user");
      let exist = this.form.share_sharers.find(
        (item) => item.sharer_number === data.user_number
      );
      let index = this.form.share_sharers.indexOf(exist);
      if (index > -1) {
        this.form.share_sharers.splice(index, 1);
      } else {
        this.form.share_sharers.push({
          sharer_name: data.name,
          name: data.name,
          sharer_number: data.user_number,
          sharer_avatar: data.avatar,
        });
      }
      this.searchUsers = [];
      this.searchUserName = "";
      this.$refs.userSearch.focus();
      this.changeSearchHeight("user-search");
    },
    addGroup(data) {
      this.errors.remove("group");
      let exist = this.form.share_sharers.find(
        (item) => item.sharer_number === data.group_number
      );
      let index = this.form.share_sharers.indexOf(exist);
      if (index > -1) {
        this.form.share_sharers.splice(index, 1);
      } else {
        this.form.share_sharers.push({
          sharer_name: data.group_name,
          sharer_number: data.group_number,
          sharer_avatar: data.group_logo,
        });
      }
      this.searchGroups = [];
      this.searchGroupName = "";
      this.changeSearchHeight("group-search");
    },
    changeSearchHeight(preName) {
      this.$nextTick(() => {
        let c1 = document.getElementsByClassName(preName + "-from3")[0];
        let height = c1.clientHeight + 119 + "px";
        let c2 = document.getElementsByClassName(preName + "-to3");
        for (let i = 0; i < c2.length; i++) {
          c2[i].style.top = height;
        }
      });
    },
    editShare() {
      switch (this.shareInfo.share_type) {
        case "user":
          this.editUserShare("user");
          break;
        case "group":
          this.editUserShare("group");
          break;
        default:
          this.editLinkShare();
          break;
      }
    },
    editUserShare(shareType) {
      if (shareType === "user") {
        if (this.form.share_sharers.length < 1) {
          this.errors.add({
            field: "user",
            msg: "请先添加用户",
          });
          return false;
        }
      } else if (shareType === "group") {
        if (this.form.share_sharers.length < 1) {
          this.errors.add({
            field: "group",
            msg: "请先添加群组",
          });
          return false;
        }
      }
      this.$validator.validate("date").then((valid) => {
        if (valid || !this.strategy) {
          let params = {
            share_number: this.shareInfo.share_number,
            sharer_target_number: this.form.share_sharers.map(function (item) {
              return item.sharer_number;
            }),
          };
          if (this.strategy) {
            params.share_constraint = {
              date: this.form.date ? this.form.date : null,
            };
          }
          editShare(params)
            .then((res) => {
              if (res.status_code === 200) {
                $("#share_edit").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        }
      });
    },
    editLinkShare() {
      let params = {
        share_number: this.shareInfo.share_number,
      };
      if (this.strategy) {
        if (this.errors.has("password") || this.errors.has("date")) {
          return false;
        } else {
          params.share_constraint = {
            date: this.form.date ? this.form.date : null,
            password: this.form.password ? this.form.password : null,
          };
        }
      }
      editShare(params)
        .then((res) => {
          if (res.status_code === 200) {
            $("#share_edit").modal("hide");
            this.$message({
              type: "success",
              message: res.message,
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    createPassword() {
      let password = Math.random().toString(36).substr(2, 4);
      this.form.password = password;
    },
    setStrategy() {
      this.strategy = !this.strategy;
    },
    removeUser(user) {
      let exist = this.searchUsers.find(
        (item) => item.user_number === user.sharer_number
      );
      if (exist) {
        exist.exist = false;
      }
      let index = this.form.share_sharers.indexOf(user);
      this.form.share_sharers.splice(index, 1);
      this.changeSearchHeight("user-search");
    },
    removeGroup(group) {
      let exist = this.searchGroups.find(
        (item) => item.group_number === group.sharer_number
      );
      if (exist) {
        exist.exist = false;
      }
      let index = this.form.share_sharers.indexOf(group);
      this.form.share_sharers.splice(index, 1);
      this.changeSearchHeight("group-search");
    },
    userSearch() {
      userSearch(this.searchUserName)
        .then((res) => {
          this.showSearchList = true;
          if (res.entity.length === 0) {
            this.noSearchUsers = true;
          } else {
            this.noSearchUsers = false;
          }
          this.searchUsers = res.entity.map((item) => {
            if (
              this.form.share_sharers.find(
                (it) => it.sharer_number === item.user_number
              )
            ) {
              item.exist = true;
            } else {
              item.exist = false;
            }
            return item;
          });
          this.changeSearchHeight("user-search");
        })
        .catch();
    },
    groupSearch() {
      getGroups({
        search_name: this.searchGroupName,
        group_review: "adopt",
      })
        .then((res) => {
          this.showSearchList = true;
          if (res.entity.total === 0) {
            this.noSearchGroups = true;
          } else {
            this.noSearchGroups = false;
          }
          this.searchGroups = res.entity.datas.map((item) => {
            if (
              this.form.share_sharers.find(
                (it) => it.sharer_number === item.group_number
              )
            ) {
              item.exist = true;
            } else {
              item.exist = false;
            }
            return item;
          });
          this.changeSearchHeight("group-search");
        })
        .catch();
    },
    getIcon(type, file_type, file_ext) {
      return getIcon(type, file_type, file_ext);
    },
    getFormatDateFocus(event) {
      $(event.currentTarget)
        .find("input:first-child")
        .datetimepicker({
          format: "yyyy-mm-dd",
          weekStart: 1,
          autoclose: true,
          startView: 2,
          minView: 2,
          pickerPosition: "bottom-right",
          language: "zh-CN",
          startDate: getFormatDate(),
        })
        .datetimepicker("show")
        .on("changeDate", (ev) => {
          this.form.date = getFormatDate(ev.date.valueOf());
        })
        .on("hide", (ev) => {
          $(ev.currentTarget).datetimepicker("remove");
        });
    },
  },
  mounted() {
    $("#share_edit").on("shown.bs.modal", () => {
      this.form.password =
        this.shareInfo.share_constraint &&
        this.shareInfo.share_constraint.password
          ? this.shareInfo.share_constraint.password
          : "";
      this.form.date =
        this.shareInfo.share_constraint && this.shareInfo.share_constraint.date
          ? this.shareInfo.share_constraint.date
          : "";
      this.form.share_sharers = [...this.shareInfo.share_sharers];
    });
  },
};
</script>

<style scoped>
.text-danger2 {
  color: red;
}
.text-danger2 a {
  color: red;
}
.text-danger2 a:hover {
  text-decoration: underline;
}
</style>